import React from "react";
import * as Styles from "./loading.styles";

export const Loading = () => (
  <Styles.SpinnerWrapper>
    <Styles.Spinner />
  </Styles.SpinnerWrapper>
);
